import { Injectable, Inject } from '@angular/core';
import { APP_CONFIG } from './config/app-config.service';
import { IAppConfig } from './config/app-config.model';
import { Subject } from 'rxjs';
import { NotifyMsgType, RoundingType } from './data/enumeration';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

export const TOAST_FOREVER = 999999;

@Injectable({
  providedIn: 'root'
})
export class UIHelper {
  destroyed = new Subject<any>();

  constructor(
    @Inject(APP_CONFIG) protected config: IAppConfig,
    private translateService: TranslateService,
    private messageService: MessageService,
  ) {}


  translate(resxKey: string, interpolateParams?: Object): string {
    return this.translateService.instant(resxKey, interpolateParams);
  }

  roundingNumber(input: number, decimalDigits: number, roundingType: string): number {
    if(!input){
      input = 0;
    }

    if(decimalDigits === undefined){
      decimalDigits = 2;
    }
    if(roundingType === undefined){
      roundingType = RoundingType.RoundOff;
    }
    var result = input;
    var decimalplaces = Math.pow(10, decimalDigits);

    switch (roundingType) {
      case RoundingType.RoundOff:
        result = Math.round(result * decimalplaces) / decimalplaces;
        break;
      case RoundingType.RoundUp:
        result = Math.ceil(result * decimalplaces) / decimalplaces;
        break;
      case RoundingType.RoundDown:
        result = Math.floor(result * decimalplaces) / decimalplaces;
        break;
      case RoundingType.Truncate:
        result = Math.trunc(result);
        break;
    }
    return result;
  }

  formatRoundingNumber(input: number, decimalDigits: number, roundingType: string): string{
    if(!input){
      input = 0;
    }
    const str = this.roundingNumber(input, decimalDigits, roundingType).toFixed(decimalDigits);
    const parts = str.split('.');
    return parts[0].replace(new RegExp(`\\B(?=(\\d{3})+(?!\\d))`, 'g'), ',') + '.' + parts[1];
  }

  today(): Date{
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate());
  }

  showMessage(resxKey: string, type: NotifyMsgType, duration?: number) {
    const message = this.translate(resxKey);
    if (type == NotifyMsgType.Success) {
      this.messageService.add({severity:'success', summary: `Success`, detail: message, key: 'toast', life: duration});
    } else if (type == NotifyMsgType.Error) {
      this.messageService.add({severity:'error', summary: `Error`, detail: message, key: 'toast', life: duration});
    } else {
      this.messageService.add({severity:'info', summary: `Information`, detail: message, key: 'toast', life: duration});
    }
  }
}
